import React from 'react';
import CustomerReportComponent from '../../../Components/Report/CustomerReport';

export default function CustomerReport() {
    return (
        <div className='page-body'>
            <CustomerReportComponent />
        </div>
    );
}